exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notion .b{font-weight:600!important}.notion .orange{color:#d9730d}", ""]);

// exports
